import { Radio } from "antd";
import { useTranslate } from "@refinedev/core";
import { HeaderPosition } from "..";

export const HeaderPositionFeature = ({
  position,
  onChange,
}: {
  position: HeaderPosition;
  onChange: (position: HeaderPosition) => void;
}) => {
  const t = useTranslate();

  const radioButtonOptions = Object.values(HeaderPosition).map((option) => ({
    label: t(
      `components.templates.settings.brandingTab.radioButtonLabels.${option}`
    ),
    value: option,
  }));

  return (
    <Radio.Group
      value={position}
      options={radioButtonOptions}
      onChange={(e) => onChange(e.target.value as HeaderPosition)}
      style={{ display: "flex", gap: 50 }}
    />
  );
};
